<!--Report>Print Price Label页面-->
<template>
    <a-modal
            :title="prompt"
            v-model="visible"
            width="80%"
            :footer="null"
            :maskClosable="false"
            @cancel="cancel"
    >

        <!---单选框选择Print Type类型-->
        <a-row>
            <a-col align="left" style="left: 50px">
                <a-form-item class="genericFrom" aria-required="true">
                    <a-radio-group @change="patternTypeChange" v-model="patternTypeVal" size="small">
                        <a-radio value="ALL">
                            {{$t('printPriceLabel.PrintAll')}}
                        </a-radio>
                        <a-radio value="SINGLE">
                            {{$t('printPriceLabel.PrintSingle')}}
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
            </a-col>
        </a-row>

        <!--上部分-->
        <a-row>
            <!--左部分-->
            <a-col span="8">
                <!--SO#-->
                <a-row class="rowTop">
                    <a-col :span="3" style="text-align:right;margin-right: 6px">{{ $t('roleGe.SO') }}: </a-col>
                    <a-col :span="17" >
                        <a-input size="small" ref="soNoQuery" v-model="soNoQuery" :placeholder="$t('roleGe.SO')" @pressEnter="orderEnter"/>
                    </a-col>
                    <a-col :span="3" style="margin-left: 2px">
                        <img class="funcButton" src="../../../assets/img/yyj.png" v-if="ifImgQuery" width="23" height="23" @click="showSku">
                    </a-col>
                </a-row>
                <!--LPN#-->
                <a-row class="rowTop">
                    <a-col :span="3" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.Lpn') }}: </a-col>
                    <a-col :span="17" >
                        <a-input size="small" v-model="lpnQuery" :placeholder="$t('pubGicSet.Lpn')" @pressEnter="orderEnter"/>
                    </a-col>
                    <a-col :span="3" style="margin-left: 2px">
                        <img class="funcButton" src="../../../assets/img/yyj.png" v-if="ifImgQuery" width="23" height="23" @click="showSku">
                    </a-col>
                </a-row>
                <!--SSCC#-->
                <a-row class="rowTop">
                    <a-col :span="3" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.SSCC1') }}: </a-col>
                    <a-col :span="17" >
                        <a-input size="small" v-model="ssccQuery" :placeholder="$t('pubGicSet.SSCC1')" @pressEnter="orderEnter"/>
                    </a-col>
                    <a-col :span="3" style="margin-left: 2px">
                        <img class="funcButton" src="../../../assets/img/yyj.png" v-if="ifImgQuery" width="23" height="23" @click="showSku">
                    </a-col>
                </a-row>
            </a-col>

            <!--右部分-->
            <a-col span="16" class="rowTop" v-if="ifShow">
                <!--SO#-->
                <a-row >
                    <a-col span="6" style="text-align: right">{{ $t('printPriceLabel.ConsigneeDeliveringTo') }}: </a-col>
                    <a-col span="4" class="rowLeft">
                        <a-input size="small" v-model="consigneeCode" disabled="false"/>
                    </a-col>
                    <a-col span="8" class="rowLeft">
                        <a-input size="small" v-model="consigneeName" disabled="false"/>
                    </a-col>
                    <a-col span="2" class="rowLeft">
                        <a-input size="small" v-model="country" disabled="false"/>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
        <br>

        <!--下部分-->
        <a-row style="margin-bottom: 10px" v-if="ifShow">
            <!--左部分-->
            <a-col span="8">
                <!--SKU#-->
                <a-row class="rowTop">
                    <a-col :span="3" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.SKU') }}: </a-col>
                    <a-col :span="17" >
                        <a-input size="small" ref="skuQuery" v-model="skuQuery" :placeholder="$t('pubGicSet.SKU')" @pressEnter="query"/>
                    </a-col>
                </a-row>
                <!--Copies#-->
                <a-row class="rowTop">
                    <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('printPriceLabel.Copies') }}: </a-col>
                    <a-col :span="12" >
                        <a-input-number size="small" v-model="copiesQuery" :placeholder="$t('printPriceLabel.Copies')"/>
                    </a-col>
                </a-row>

            </a-col>

            <!--右部分-->
            <a-col span="16" class="rowTop">
                <a-row style="margin-top: 5px" type="flex" justify="end">
                    <a-col >
                        <a-pagination
                                :pageSizeOptions="pageSizeOptions"
                                :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                                size="small"
                                :total="pagingTotal"
                                v-model="currentVal"
                                :pageSize.sync="pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                showSizeChanger
                        />
                    </a-col >
                </a-row>
                <a-row >
                    <!--列表-->
                    <vxe-table
                            stripe
                            border
                            highlight-hover-row
                            resizable
                            size="mini"
                            :data.sync="tableData"
                            ref="deallccationRefs">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="sscc" :title="$t('pubGicSet.SSCC1')"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="sku" :title="$t('pubGicSet.SKU')"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="packedQty" :title="$t('pubGicSet.PackedQty')"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="udf5" :title="$t('printPriceLabel.PrintedQty')"></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-col>
        </a-row>

        <a-button size="small" type="primary" style="width:100px;margin-left: 50px;margin-bottom: 30px;" @click="query">{{ $t('pubGicSet.Print') }}</a-button>
    </a-modal>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import webSocketPrint from "./webSocketPrint";

    export default {
        data() {
            return {
                visible: false,
                patternTypeVal: "ALL",
                prompt:"Print All – Scan/Input SO#, LPN# or SSCC#",
                soNoQuery:"",
                lpnQuery:"",
                ssccQuery:"",
                consigneeCode:"",
                consigneeName:"",
                country:"",
                skuQuery:"",
                copiesQuery:1,
                tableData: [],
                ifShow:false,
                ifImgQuery:false,
                pagingTotal: 0, // 总数
                pagingSize: 10, // 条数
                currentVal: 1, // 当前选中的页数
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                printers:[],
            }
        },
        methods: {
            show() {
                this.visible = true
                this.$refs.soNoQuery.focus();
            },
            tableChangePage(current) {
                this.currentSkuVal = current;
                this.queryLotId();
            },
            onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
                this.currentSkuVal = current;
                this.pagingSkuSize = pageSize;
                this.queryLotId();
            },
            orderEnter(){
                if("SINGLE"==this.patternTypeVal){
                    this.showSku();
                    this.queryDetail();
                }else{
                    this.query();
                }
            },
            query(){
                if("SINGLE"==this.patternTypeVal){
                    if((null==this.soNoQuery||""==this.soNoQuery)&&(null==this.lpnQuery||""==this.lpnQuery)&&(null==this.ssccQuery||""==this.ssccQuery)){
                        this.prompt = "Print Single – Invalid Data.";
                        return;
                    }
                    if(null==this.skuQuery||""==this.skuQuery||null==this.copiesQuery||this.copiesQuery<1){
                        this.prompt = "Print Single – Invalid Data.";
                        this.$refs.skuQuery.focus();
                        return;
                    }
                }else{
                    if((null==this.soNoQuery||""==this.soNoQuery)&&(null==this.lpnQuery||""==this.lpnQuery)&&(null==this.ssccQuery||""==this.ssccQuery)){
                        this.prompt = "Print All – Invalid Data.";
                        return;
                    }
                }
                this.autoPrintPrice();
            },
            showSku(){
                if((null==this.soNoQuery||""==this.soNoQuery)&&(null==this.lpnQuery||""==this.lpnQuery)&&(null==this.ssccQuery||""==this.ssccQuery)){
                    this.prompt = "Print Single – Invalid Data.";
                    return;
                }
                this.ifShow=true;
                this.prompt = "Print Single – Scan SKU.";
                // this.$refs.skuQuery.focus();
            },
            queryDetail(){
                let params = {
                    currentVal: this.currentVal,
                    pagingSize: this.pagingSize,
                    soNo: this.soNoQuery,
                    lpn: this.lpnQuery,
                    sscc: this.ssccQuery,
                }
                ajax.get(api.QUERYDETAILPRINTPRICE,params).then(res=>{
                    if(res.code == 200){
                        this.tableData = res.data;//列表
                        this.pagingTotal = res.total;//总数
                        if(this.pagingTotal > 0){//如果只有一条数据,自动填充
                            this.consigneeCode = this.tableData[0].partnerCode;
                            this.consigneeName = this.tableData[0].partnerName;
                            this.country = this.tableData[0].partnerCountry;
                            this.$refs.skuQuery.focus();
                        }else{
                            this.consigneeCode = "";
                            this.consigneeName = "";
                            this.country = "";
                            this.prompt = "Print Single – No Data.";
                        }
                    }
                })
            },
            //自动打印   --   调用之前需做校验
            autoPrintPrice(){
                this.getPrinters();
                let params = {
                    ip: this.ip,
                    type: this.patternTypeVal,
                    soNo: this.soNoQuery,
                    lpn: this.lpnQuery,
                    sscc: this.ssccQuery,
                    sku: this.skuQuery,
                    copies: this.copiesQuery
                }
                ajax.get(api.AUTOPRINTPRICE,params).then(res=>{
                    if(res.code == 200){
                        if (res.data.length>0) {
                            let isSuccess = true;
                            for (let i = 0; i < res.data.length; i++) {
                                if(res.data[i]==null){
                                    continue;
                                }
                                if (res.data[i].type == null) {
                                    isSuccess = false;
                                    if("SINGLE"==this.patternTypeVal){
                                        this.prompt = "Print Single – Invalid Data.";
                                    }else{
                                        this.prompt = "Print All – Invalid Data.";
                                    }
                                    continue;
                                }
                                if(res.data[i].errorMsg!=null&&res.data[i].errorMsg!=""){
                                    isSuccess = false;
                                    continue;
                                }
                                if(res.data[i].printerName==null||res.data[i].printerName==""){
                                    isSuccess = false;
                                    continue;
                                }
                                console.log("printerNames:"+res[i].printerName);
                                let printerName = "";
                                let printerNames = res[i].printerName.split(",");
                                for(var j = 0;j<this.printers.length;j++){
                                    for(var k = 0;k<printerNames.length;k++){
                                        if(this.printers[j].name==printerNames[k]){
                                            printerName = printerNames[k];
                                            break;
                                        }
                                    }
                                    if(printerName!=""&&printerName!=null){
                                        break;
                                    }
                                }
                                console.log("printerName:"+printerName);
                                if(printerName!="") {
                                    res[i].printerName = printerName;
                                    if(res.data[i].fileBytes.length>125000){
                                        let oldFileBytes = res.data[i].fileBytes;
                                        let part = Math.ceil(oldFileBytes.length/125000);//分批数
                                        for (let j = 0; j < part; j++)
                                        {
                                            let fileBytes = "";
                                            if (oldFileBytes.length>125000) {
                                                fileBytes = oldFileBytes.substring(0, 125000);
                                                oldFileBytes = oldFileBytes.substring(125000, oldFileBytes.lenght);
                                                res.data[i].logId = 1;//1表示发送多次还未发完
                                            } else {
                                                fileBytes = oldFileBytes.substring(0, oldFileBytes.lenght);
                                                oldFileBytes = "";
                                                res.data[i].logId = 2;//2表示发送多次已发完
                                            }
                                            res.data[i].fileIndex = j;//当前发送位置
                                            res.data[i].fileCount = part;//表示发送多次已发完
                                            res.data[i].fileBytes = fileBytes;
                                            webSocketPrint.doPrint("9999",JSON.stringify(res.data[i]));
                                        }
                                    }else{
                                        res.data[i].fileCount = 1;//1表示一次发完
                                        webSocketPrint.doPrint("9999",JSON.stringify(res.data[i]));
                                    }
                                }
                            }
                            if(isSuccess){
                                let no = "";
                                if("SINGLE"==this.patternTypeVal){
                                    if(null!=this.skuQuery&&""!=this.skuQuery){
                                        no = this.skuQuery;
                                    }
                                    this.prompt = "Print Single – Labels are printed for ["+no+"].";
                                    this.cancelSku();
                                    this.queryDetail();
                                }else{
                                    if(null!=this.soNoQuery&&""!=this.soNoQuery){
                                        no = this.soNoQuery;
                                    }
                                    if(null!=this.lpnQuery&&""!=this.lpnQuery){
                                        if(no.length>0){
                                            no = no + "/" + this.lpnQuery;
                                        }else{
                                            no = this.lpnQuery;
                                        }
                                    }
                                    if(null!=this.ssccQuery&&""!=this.ssccQuery){
                                        if(no.length>0){
                                            no = no + "/" + this.ssccQuery;
                                        }else{
                                            no = this.ssccQuery;
                                        }
                                    }
                                    this.prompt = "Print All –  Labels are printed for ["+no+"].";
                                    this.cancelOrder();
                                }
                            }
                        }
                    }else{
                        if("SINGLE"==this.patternTypeVal){
                            this.prompt = "Print Single – Invalid Data.";
                        }else{
                            this.prompt = "Print All – Invalid Data.";
                        }
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            cancel(){
                this.soNoQuery="";
                this.lpnQuery="";
                this.ssccQuery="";
                this.skuQuery="";
                this.copiesQuery=1;
                this.consigneeCode="";
                this.consigneeName="";
                this.country="";
                this.tableData= [];
                this.ifShow=false;
                this.ifImgQuery=false;
            },
            cancelOrder(){
                this.soNoQuery="";
                this.lpnQuery="";
                this.ssccQuery="";
            },
            cancelSku(){
                this.skuQuery="";
            },
            cancelConsignee(){
                this.consigneeCode="";
                this.consigneeName="";
                this.country="";
            },
            cancelList(){
                this.tableData= [];
            },
            patternTypeChange(){
                this.cancel();
                if(this.patternTypeVal=="SINGLE"){
                    this.prompt="Print Single – Scan/Input SO#, LPN# or SSCC#";
                    this.ifImgQuery=true;
                }else{
                    this.prompt="Print All – Scan/Input SO#, LPN# or SSCC#";
                }
            },
            // 获取用户本地ip的方法
            getUserIP (onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
                let pc = new MyPeerConnection({
                    iceServers: []
                })
                let noop = () => {

                }
                let localIPs = {}
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip)
                    localIPs[ip] = true
                }
                pc.createDataChannel('')
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return
                        line.match(ipRegex).forEach(iterateIP)
                    })
                    pc.setLocalDescription(sdp, noop, noop)
                }).catch((reason) => {
                })
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
                }
            },
            getPrinters(){
                let that = this;
                if ("WebSocket" in window)
                {
                    // Create websocket
                    var ws = new WebSocket("ws://localhost:9999/print");
                    ws.onopen = function()
                    {
                        ws.send("{'Type':'SERVER_INFO'}");
                    };
                    ws.onmessage = function (evt)
                    {
                        var msg = evt.data;
                        try {
                            that.printers = JSON.parse(msg).printerServer.printers;
                        } catch (e) {
                        }
                    };
                    ws.onclose = function()
                    {

                    };
                }
                else
                {

                }
            },
        },
        mounted(){
            this.getUserIP((ip) => {
                this.ip = ip;
            });
        }
    }
</script>
<style scoped>
    .ant-modal-header{
        background-color: #e6e6e6;
        border-bottom: 1px solid silver;
    }
    .rowTop {
        margin-top: 20px
    }
    .rowLeft {
        margin-left: 5px
    }
</style>